import { Col, Row, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CountriesList from "./countriesList";
import { useMutation } from "react-query";
import { getCountriesApi } from "../../../api/countries";
import { AddEditCountrie } from "./AddEditCountries";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";

const Countries = () => {
  const { t } = useTranslation("common");
  const [openCountrie, setOpenCountrie] = useState(false);
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedCountries, setPaginatedCountries] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    getCountries({
      limit: page * 8 + 8,
      q: "",
    }).then((res) => {
      setPaginatedCountries(res.data?.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getCountries({
      limit: page * 8 + 8,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedCountries(res.data?.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getCountries({
      limit: page * 8 + 8,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedCountries(res.data?.data);
    });
  };

  const getCountries = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await CountriesMutation(params);
  };

  const { mutateAsync: CountriesMutation, isLoading: isCountriesLoading } =
    useMutation("countries", getCountriesApi);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>

          <Button
            disabled={true}
            icon={<PlusOutlined />}
            style={{
              backgroundColor: "#1677FF",
              color: "#fff",
              height: "40px",
            }}
            onClick={() => setOpenCountrie(true)}
          >
            {t("add")}
          </Button>
        </Col>
        <Col span={24} className="">
          <CountriesList
            CountriesMutation={CountriesMutation}
            paginatedCountries={paginatedCountries}
            setPaginatedCountries={setPaginatedCountries}
            isCountriesLoading={isCountriesLoading}
            search={search}
            filter={filter}
            page={page}
            setPage={setPage}
            tableKey={tableKey}
          />
        </Col>
      </Row>
      {openCountrie && (
        <AddEditCountrie
          openCountrie={openCountrie}
          setOpenCountrie={setOpenCountrie}
          search={search}
          filter={filter}
          setPaginatedCountries={setPaginatedCountries}
          CountriesMutation={CountriesMutation}
        />
      )}
    </>
  );
};

export default Countries;
